import "./styles.less"
import { useSearchResultsPagination } from "./SearchResultsPagination.hook"
import { useRouter } from 'next/router'

export const SearchResultsPagination = ({error,loading,paginatorInfo}) => {
	const {
		changePage,
		data: { currentPage, perPage, total, lastPage },
	} = useSearchResultsPagination( paginatorInfo);

	const { asPath } = useRouter()

	if (error || loading) return null;

	const genPagURL = (page) => {
		const [ urlSegments, paramString ] = asPath.split( '?' )
		let totalPages = Math.ceil(total / perPage)
		let basePath = urlSegments
		.replace( /pagina([0-9]+)?\/?$/gm , '')
		.split('/')
		.filter(e => e && e.length)

		if(page > 1 && page <=totalPages) 
			basePath = [...basePath, `pagina${page}`]

		let newPagURL = '/'+basePath.join('/')
		newPagURL = paramString ? newPagURL.concat('?',paramString) : newPagURL

		return newPagURL
	}


	return <ul className="search-results-pagination" role="navigation" aria-label="Pagination">
		{currentPage>1 && 
			<li className="ant-pagination-item" >
				<a className="ant-pagination-item-link" 
					href={genPagURL(currentPage-1)} 
					rel="nofollow"
					onClick={(e)=>{
						e.preventDefault()
						window.scrollTo(0, 0)
						changePage(currentPage-1)
					}}
				> {'<'} </a>
			</li>
		}

		{generatePaginationArray( lastPage , currentPage).map((item,i) => {
			let isDotts = item == '+...' || item == '-...'
			let page =  isDotts ? ( item == '+...' ? currentPage+4 : currentPage-4 ) : item 
			let cssClass = `ant-pagination-item ${!isDotts && currentPage==item ? 'ant-pagination-item-active' :''}  `

			return <li className={cssClass} key={i}>
				{currentPage==item 
					? <span className="ant-pagination-item-link" aria-label="current page">{page}</span>
					: <a className="ant-pagination-item-link" 
						href={genPagURL(page)} 
						aria-label={!isDotts ?`Page ${page}`:null} 
						rel="nofollow"
						onClick={(e)=>{
							e.preventDefault()
							window.scrollTo(0, 0)
							changePage(page)
						}}
					>{isDotts? '...' : page}</a>
				}
				
			</li>
		})}

		{currentPage<lastPage && 
			<li className="ant-pagination-item" >
				<a className="ant-pagination-item-link" 
					href={genPagURL(currentPage+1)}  
					rel="nofollow"
					onClick={(e)=>{
						e.preventDefault()
						window.scrollTo(0, 0)
						changePage(currentPage+1)
					}}
				> {'>'} </a>
			</li>
		}
	</ul>

	
};

const generatePaginationArray = (totalPages, currentPage) => {
    let res = []
    // For Precaution
    currentPage = (Math.min(Math.max(0, currentPage), totalPages - 1));

	if(totalPages <= 12){
        for (let i = 1; i <= totalPages; i++) {
            res.push(i)
        }
        return res
    }
    
    if(currentPage <= 6){
        for (let i = 1; i <= 7; i++) {
            res.push(i)
        }
        res = [...res, '+...', totalPages]
    }else if(currentPage >= totalPages-4){
        for (let i = totalPages-6; i <= totalPages; i++) {
            res.push(i)
        }
        res = [1, '-...', ...res]
    }else{
        for (let i = currentPage-2; i <= currentPage+2; i++) {
            res.push(i)
        }
        res = [1, '-...', ...res, '+...', totalPages]
    }

    return res
}